import React from 'react';
import { InputBase } from '../../../Helper/InputBase';
import { NormalizationConstants } from '../../../../constants';

  const RentalAddress = (props) => {
    const { streetAddress, city, postalCode, errors, handleChange, disabled } = props;

    const handlePostalCodeChange = (e) => {
      let target = e.target, 
        position = target.selectionEnd, 
        length = target.value.length;
      
      e.target.value = e.target.value.toUpperCase();
      e.target.value = target.value.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
      e.target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
      handleChange(e);
    }

    return (
      <div className="rental-address hide-print">
        <InputBase
          name='streetAddress'
          disabled={disabled}
          errors={errors?.streetAddress}
          value={streetAddress}
          cssClass='rental-address__street'
          type='text'
          topLabel='Street Address'
          maxLength={NormalizationConstants.maxAddressLength}
          handleChange={handleChange}
        />
        <div className="rental-address__city-postal">
          <InputBase
            name='city'
            disabled={disabled}
            errors={errors?.city}
            value={city}
            cssClass='rental-address__city'
            type='text'
            topLabel='City'
            maxLength={NormalizationConstants.maxCity}
            handleChange={handleChange}
          />

          <InputBase
            name='postalCode'
            disabled={disabled}
            errors={errors?.postalCode}
            value={postalCode.toUpperCase()}
            cssClass='rental-address__postal'
            type='text'
            topLabel='Postal Code'
            maxLength={NormalizationConstants.maxPostalCode}
            handleChange={handlePostalCodeChange}
          />

        </div>
        <p>British Columbia, Canada</p>
      </div>
    )
  }

export default RentalAddress;